export enum CancellationPlanEnum {
    Easy = 1,
    Normal = 2,
    Hard = 3
}